import {Vector2d} from "konva/lib/types";
import {IAttachedInStatusNode, IStatusNodeGraph} from '../../../models/graph.model'
import {Layer} from "konva/lib/Layer";
import {Rect} from "konva/lib/shapes/Rect";
import {BUSINESS_PROCESS_LAYER_ID, CONTRACT_LAYER_ID, IKnUIOptions, TNodeTypes} from "./graph-kn.cm-api-models";
import {CompanyContractModel, ContractStepModel} from "../../../models/contract.model";
import { Observable } from "rxjs";
import { Position } from "./graph-kn.model-enums";
import { IMemberWithRole, MemberModel } from "../../../models/user.model";
import { IRolesGroups } from "../../../models/task.model";
import { StatusNodeModel } from "../../../models/tasktable.model";

export type TGraphType = typeof CONTRACT_LAYER_ID | typeof BUSINESS_PROCESS_LAYER_ID
export type TGraphActionType = 'delete' | 'add' | 'modify'
export const NODE_STATUSES = ['is_initial', 'is_finish', 'is_successful', 'is_archive', 'is_universal', 'to_archive', 'attachments'] as const
export const ATTACHMENT_TYPES = ['attachments_files', 'attachments_images'] as const
export type TNodeStatus = (typeof NODE_STATUSES)[number]
export type TAttachmentType = (typeof ATTACHMENT_TYPES)[number]
export type TCanvasObject = Record<string, ICanvasObject>
export type IFullGraphData = IGraphData & { state?: string } & { projects?: CompanyContractModel[] }
export type TStoredSetting = 'contract_graph_type'

export interface IDimensions {
    width: number,
    height: number
}

export interface ILayerData {
    layer: Layer,
    dimensions: IDimensions,
    dragRect: Rect,
}

export interface ICanvasObject {
    contextMenu: boolean
}

export interface IGraphAction {
    action: TGraphActionType,
    id: string
}

export interface ITagretsNodes {
    contractState: string,
    state: string,
    node: IGraphNode,
    x: number,
    y: number,
    sides?: IRectSides,
    step_completed?: boolean,
    target_completed?: boolean,
    active_step?: boolean,
    target_errors?: boolean,
}

export interface IConnectorsEdges {
    id: string,
    nodeType?:TNodeTypes,
    edge_id?:string,
    from: string,
    fromRelativePos?:Vector2d,
    fromEdgePos?:Position,
    to: string,
    toRelativePos?:Vector2d,
    toEdgePos?:Position
    points?: Vector2d[],
    points_labels?: Vector2d[],
    relativePointsData?:number[],
    data: any,
    moveAlg?: 'save' | 'calc',
    active?: boolean,
    fixedFromToPositions?:boolean 
}

interface IRectSides {
    top: number,
    right: number,
    bottom: number,
    left: number,
}

export interface Edge {
    id?: string;
    source: string;
    target: string;
    label?: string;
    data?: any;
    points?: any;
    points_labels:Vector2d[]
    line?: string;
    textTransform?: string;
    textAngle?: number;
    oldLine?: any;
    oldTextPath?: string;
    textPath?: string;
    midPoint?: any;
    contextMenu?: boolean,
    moveAlg?: 'save' | 'calc',
    active?: boolean
}

export interface IRestrictionStepOrder {
    credit_letter_guid?: string,
    guidStep: string,
    typeRestriction: 'after' | 'before',
    guidsLinkedSteps: string[]
}

//temp interfaces
//npx-graph
export interface NodePosition {
    x: number;
    y: number;
}

export interface NodeDimension {
    width: number;
    height: number;
}

export interface IGraphData {
    activeStepId?: string,
    stateContract?: string
    nodes: IGraphNode[];
    edges: Edge[];
    allUsers?:string[]
    allMembersData?:MemberModel[]
}

export interface NodePosition {
    x: number;
    y: number;
}

export interface NodeDimension {
    width: number;
    height: number;
}

export interface Node {
    data:any,
    id: string;
    is_archive?:boolean,
    state?: 'active' | 'none';
    transform?: string;
    label?: string;
    meta?: any;
    layoutOptions?: any;
    parentId?: string;
    hidden?: boolean;
    contextMenu?: boolean,
    children?: Node[],
    description?: string,
    roles?: IRolesGroups
    edgeId?:string,
    position: NodePosition;
    dimension: NodeDimension;
}
export interface IStatusNodeModelExt extends StatusNodeModel {
        parent?:string,
        members?:MemberModel[]
    }
export interface IContractStepModelExt extends ContractStepModel {
    stepNumber?:string
}
export type TGraphNodeDataType = IStatusNodeModelExt|IContractStepModelExt|ITaskStatusGraphData
export interface IGraphNode {
    id:string,
    label:string,
    nodeType:TNodeTypes,
    position: NodePosition;
    dimension: NodeDimension;
    parent?:string,
    state?: string;
    image?:string|undefined,
    contract_step_data?: IContractStepModelExt;
    bp_status_data?:IStatusNodeModelExt
    task_data?:ITaskStatusGraphData
    
}
export interface ITaskStatusGraphData extends IStatusNodeGraph{
}
export interface IStorageSettings {
    setting_id: TStoredSetting
    setting_value: string
}
export interface Graph {
    edges: Edge[];
    nodes: Node[];
    edgeLabels: any;
    rankCount?: number,
    rowCount?: number
}
export interface Layout {
    settings?: any;

    run(graph: Graph): Graph | Observable<Graph>;

   // updateEdge(graph: Graph, edge: Edge): Graph | Observable<Graph>;

    onDragStart?(draggingNode: Node, $event: MouseEvent): void;

    onDrag?(draggingNode: Node, $event: MouseEvent): void;

    onDragEnd?(draggingNode: Node, $event: MouseEvent): void;
}
interface IAdComponentDataBase {
  top:number,
  left: number,
  visibility:'hidden'|'visible',
  width?:number,
}
export interface IAdComponentData extends IAdComponentDataBase {
  data?:IMemberWithRole[]|IGraphNode,
  rights?:IKnUIOptions,
}
export interface IAttachmentsData extends IAdComponentDataBase {
    data?:IAttachedInStatusNode[], 
    attachType?:'file'|'photo',
    task_alias?:string
}
export interface IIconData {
    id?:string
    iconPath:string
    position:Vector2d,
    iconHeight:number
    offsetX:number,
    offsetY:number,
    iconBackGroundColor:string,
    iconBackGroundRadius:number,
    iconBackGroundHeight:number,
    activeIcon?:boolean,
    tooltip?:{
        text?:string,
        offsetX?:number,
        offsetY?:number,
        tooltipBackGround?:string
    }
    badge?:{
        qty?:string,
        offsetX?:number,
        offsetY?:number,
        backGround?:string
    }
}